<input type="hidden" name="menuType" id="menuType" value="secure" />
<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <h2 id="pageTitle">{{'bss.myServices.title'| translate}}</h2>
        <hr>
    </div>
</div>

<div class="ontario-row">
    <div class="ontario-column ontario-small-12">

        <p>{{'bss.myServices.subTitle'| translate}}</p>
        <div *ngIf="currentLanguage === 'en'">
            <ul>
                <li *ngFor="let service of services; let i = index">
                    <a [href]="service.serviceUrlEN" title="{{ service.serviceNameEN }}" class="hover-link" target="_self" tabindex="100+ i">
                        {{ service.serviceNameEN }}
                    </a>
                    <div *ngIf="service.serviceMessageEN" class="hover-div"><dl><dt></dt><dd>{{ service.serviceMessageEN }}</dd></dl></div>
                </li>
            </ul>
        </div>
        <div *ngIf="currentLanguage === 'fr'">
            <ul>
                <li *ngFor="let service of services; let i = index">
                    <a [href]="service.serviceUrlFR" title="{{ service.serviceNameFR }}" class="hover-link" target="_self" tabindex="100+ i">
                        {{ service.serviceNameFR }}
                    </a>
                    <div *ngIf="service.serviceMessageFR" class="hover-div"><dl><dt></dt><dd>{{ service.serviceMessageFR }}</dd></dl></div>
                </li>
            </ul>
        </div>
        <p>{{'bss.myServices.subTitle.2'| translate}}</p>
        <button tabindex="100 + servicesLength + 1" class="ontario-button ontario-button--primary"
            (click)="viewProfile()" title=" {{'bss.myServices.goback.title' | translate }}">
            {{'bss.myServices.goback' | translate }}
        </button>
    </div>
</div>